


namespace Gordic.Epk.WebControls {

    interface IKpiOut {
        vyrizuje: EpkScoreboardParams[],
        zada: EpkScoreboardParams[],
        colors: EpkScoreboardParams[]
    }

    export enum EpkScoreboardNavigateEnum {
        KVyrizeni = 1,
        VracenoKPrepracovani = 2,
        PosouzenoSchvaleno = 3,
        VlastniZadosti = 6
    }

    export interface IScoreboardNavigateParam {
        content: GContentType<any>;
        /** typ seznamu */
        type: EpkScoreboardNavigateEnum,
        taskId: string,
        ID: string,
        actionName: string;
        epkTermin?: Epk.WebControls.EpkTerminEnum;
        stavZadosti?: Wfl.Interface.GWflczpvEnum;
        supervisor?: number,
        uzo?: string,
        customClass?: string,
        cardView?: boolean
    }

    export interface ScoreboardItemData {
        value: any;
        description: string;
        meaning: string;
        partValue?: string;
        partPrimary?: string;
        partSecondary?: string;
    } 

    interface IScoreboardItem {
        value: number,
        description: string,
        /** "info" | "negative" */
        meaning: string,
        action: GAction
    }

    /** interface pro navigaci na konkrétní seznam */
    interface IScoreboardNavigate {
        /**
         * navigace na seznam
         * 
         * @param {IScoreboardNavigate} param parametry
         */
        navigate(param: IScoreboardNavigateParam): void;
    }

    /** typ nástěnky */
    interface IScoreboardType {
        /**
         * nastavení všech částí nástěnky
         */
        set(params: EpkScoreboardParams[]): IScoreboardItem[];
        /** vytvořit část nástěnky pro konkrétní typ */
        create(itemData: ScoreboardItemData, navigateData: IScoreboardNavigateParam): IScoreboardItem;
    }

    interface IEpkScoreboardOpt {
        epk_prehl_org: number
    }

    export class EpkScoreboardParams{
        itemData: ScoreboardItemData;
        navigateData: IScoreboardNavigateParam;
    }
  
    /** Scoreboard pro EPK */
    export class EpkScoreboard {

        /** příznak mobilního zobrazení z webconfigu */
        private EpkMobile: "0" | "1";

        constructor (EpkMobile: "0" | "1"){
            this.EpkMobile = EpkMobile;
        }

        private scoreboardItem: Gordic.Epk.WebControls.ScoreboardItem = new ScoreboardItem();

        getItem(cnt: GContentType<any>, modelCounts: any, visible: { vraceno: boolean, vyrizeno: boolean, vlastni: boolean }, opt?: IEpkScoreboardOpt) {

            var list: IGDashboardPanelOptions[] = [];
            var kpi = this.generateKpi(cnt, modelCounts, visible, opt);
            var data = this.getItems(cnt, kpi.vyrizuje, kpi.zada, kpi.colors, opt);

            this.setSettings(cnt);

            if (this.cardDisplay === true) 
                this.createCardDisplay(cnt, list, kpi);                // zatím pouze v EPK
            else 
                this.createOldDisplay(cnt, list, data);

            return list;
        }

        //#region -- settings --

        private cardDisplay: boolean;
        private cardGrid: boolean;

        private setSettings(cnt: GContentType<any>) {

            if (this.EpkMobile == "1") {
                this.cardDisplay = true;
                this.cardGrid = true;
                return;
            }

            this.cardDisplay = false;
            if (cnt.globalSettings != null) {
                var value: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.CardDisplay");
                this.cardDisplay = value == null ? false : value;
            }

            this.cardGrid = false;
            if (cnt.globalSettings != null) {
                var value: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.CardGrid");
                this.cardGrid = value == null ? false : value;
            }

        }

        //#endregion

        createUSU(cnt: GContentType<any>, modelCounts: any, visible: { vraceno: boolean, vyrizeno: boolean, vlastni: boolean }, opt?: IEpkScoreboardOpt) {
            var kpi = this.generateKpi(cnt, modelCounts, visible, opt);
            var data = this.getItems(cnt, kpi.vyrizuje, kpi.zada, kpi.colors, opt);
            return data;
        }

        private createOldDisplay(cnt: GContentType<any>, list: IGDashboardPanelOptions[], data: any[]) {

            const dataView = new Gordic.Data.View(data, { key: "name" });

            var epkItem: IGDashboardPanelOptions = {
                title: "jres:32000519", //RC 32000519 : Úvodní počty
                id: "scorecardItems",
                mode: "vertical",
                defaultSelected: false,
                itemTemplate: Gordic.Prefabs.Panels.kpiMultiRowsTemplate().itemTemplate,
                // @ts-ignore
                zone: 0,
                data: dataView,
                tooltipOptions: (row) => {

                    var tooltip = false;
                    if (row.name === "epkItemsVyriz" || row.name === "epkItemsZada")
                        tooltip = true;

                    var res: Gordic.Widget.IGTooltipOptions = {
                        tooltip: tooltip ? "jres:32001066" : "" //RC 32001066 : N znamená Nepřečteno, C znamená Celkem.
                    }
                    return res;
                },
                menuParams: [
                    {
                        icon: "fa-retweet",
                        action: new GAction({
                            name: "actRefresh",
                            captionVisible: GAction.captionVisibility.never,
                            caption: "jres:32001068", //RC 32001068 : Aktualizovat
                            visible: true,
                            run: (ev, ctx) => {
                                cnt.load();
                            }
                        })
                    }
                ]
            };
            list.push(epkItem);
        }

        //todo:
        private createCardDisplay(cnt: GContentType<any>, list: IGDashboardPanelOptions[], kpi: IKpiOut) {

            var vyrizuje: IGDashboardPanelOptions | null = null;
            var zada: IGDashboardPanelOptions | null = null;
            var color: IGDashboardPanelOptions | null = null;

            if(kpi.vyrizuje.length > 0)
                vyrizuje = this.createKpi(kpi.vyrizuje, "IdVyrizuje", "jres:32000890", 1, 0); //RC 32000890 : Vyřizuje v EPK
            if (kpi.zada.length > 0)
                zada = this.createKpi(kpi.zada, "IdZada", "jres:32000891", 0, 1); //RC 32000891 : Žádá v EPK

            var colorbarPrimary = false;
            var colorbarTitle = "jres:32000892"; //RC 32000892 : Barevné označení

            if (cnt.globalSettings != null) {
                var value: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.ColorbarPrimary");
                colorbarPrimary = value == null ? false : value;

                var title: string = cnt.globalSettings.get("Global.Epk.AppSettings.NameColorbar");
                if (title != null && title !== "")
                    colorbarTitle = title;
            }

            if (kpi.colors.length > 0)
                color = this.createKpi(kpi.colors, "IdBarvy", colorbarTitle, 1, 2); 

            if (colorbarPrimary === true) {
                if (color != null)
                    list.push(color);
            }

            if(vyrizuje != null)
                list.push(vyrizuje);
            if (zada != null)
                list.push(zada);

            if (colorbarPrimary === false) {
                if (color != null)
                    list.push(color);
            }

            return list;
        }

        private createKpi(params: EpkScoreboardParams[], id: string, title: string, zone: number, zones: number) {

            let templateData: KpiTemplateData[] = [];

            for (var index = 0; index < params.length; index++) {

                let item = params[index];
                var meaning = item.itemData.meaning;

                var partValue = item.itemData.partValue;
                var partPrimary = item.itemData.partPrimary;
                var partSecondary = item.itemData.partSecondary;

                var value = item.itemData.value;
                if (partValue != null && partValue !== "")
                    value = partValue;

                var description = item.itemData.description;
                if (partPrimary != null && partPrimary !== "")
                    description = partPrimary;

                var secondaryText = "";
                if (partSecondary != null && partSecondary !== "")
                    secondaryText = partSecondary;

                let kdata: KpiTemplateData = {
                    primaryText: description,
                    secondaryText: secondaryText,
                    value: value,
                    meaning: meaning,
                    // @ts-ignore
                    navigateData: item.navigateData
                }
                templateData.push(kdata);
            }



            let opt: IGDashboardPanelOptions = {
                itemrendered: (ev) => {
                    $(ev.target).attr('id', 'epk-cardpanel');
                    //.attr('class', 'epk-kpi');
                },
                title: title, 
                id: id,
                mode: "vertical",
                defaultSelected: false,
                itemTemplate: (data) => {

                    //todo: doplnit barvy do USU ??
                    var meaning: "info" | "negative" | "positive" | "purple" | "yellow" | "black" = data.meaning;

                    var colorClass = "";
                    if (data.navigateData.uzo != null && data.navigateData.uzo !== "") {
                        switch (meaning) {
                            case "info":        // blue
                                colorClass = "epk-card-blue";
                                break;
                            case "negative":    // red
                                colorClass = "epk-card-red";
                                break;
                            case "positive":    // green
                                colorClass = "epk-card-green";
                                break;
                            case "yellow":      // žlutá
                                colorClass = "epk-card-yellow";
                                break;
                            case "purple":      // fialová
                                colorClass = "epk-card-purple";
                                break;
                            default:
                                break;
                        }
                    }

                    var res = Gordic.Prefabs.Panels.kpiValueTwoRowsTextTemplate().itemTemplate(data) as JQuery<HTMLElement>;

                    $(res).addClass(colorClass).addClass("epk-card-c")
                        .click((ev) => {
                            ev.preventDefault();
                            // @ts-ignore
                            if (window.omedis === 1 && this.cardGrid === true) {
                                // pokud je nastaveno DEMO a máme povolený cardGrid a jedná se o seznam k vyřízení, tak to zobrazíme
                                data.navigateData.cardView = data.navigateData.type === EpkScoreboardNavigateEnum.KVyrizeni ? true : false;
                            }
                            var ScoreboardNavigate = new Gordic.Epk.WebControls.ScoreboardNavigate();
                            ScoreboardNavigate.navigate(data.navigateData);
                        });

                    return res;
                },
                // @ts-ignore
                zone: 0,
                zones: 0,
                data: new Gordic.Data.View(templateData),
                //defaultAction: new GAction({
                //    name: "act" + id,
                //    run: (ev, obj) => {
                //        var ScoreboardNavigate = new Gordic.Epk.WebControls.ScoreboardNavigate();
                //        ScoreboardNavigate.navigate(obj.item.data.navigateData);
                //    }
                //})
            };
            return opt;
        }

        private getItems(cnt: GContentType<any>, vyrizuje: EpkScoreboardParams[], zada: EpkScoreboardParams[], colors: EpkScoreboardParams[], opt?: IEpkScoreboardOpt) {
            var data: any[] = [];

            var colorbarPrimary = false;
            if (cnt.globalSettings != null) {
                var value: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.ColorbarPrimary");
                colorbarPrimary = value == null ? false : value;
            }

            /** přidaný titulek */
            var addedTitle = "";
            if (opt != null) {
                if (opt.epk_prehl_org === 1)
                    addedTitle += " (jres:32000732)"; //RC 32000732 : Celý úřad
                else if (opt.epk_prehl_org === 2)
                    addedTitle += " (jres:32000755)"; //RC 32000755 : Spisový uzel
            }

            let titleColor = "jres:32000879"; //RC 32000879 : Barevné označení v EPK
            if (cnt.globalSettings != null) {
                var nameColorbar: string = cnt.globalSettings.get("Global.Epk.AppSettings.NameColorbar");
                if (nameColorbar != null && nameColorbar !== "")
                    titleColor = nameColorbar;
            }
            titleColor += addedTitle;

            if (colorbarPrimary === true) {
                var kpi = this.setColorKpi(cnt, colors, titleColor);
                if (kpi != null)
                    data.push(kpi);
            }

            if (vyrizuje != null && vyrizuje.length > 0) {
                data.push(new GObservableObject({
                    id: "VyrizujeEpk",
                    title: "jres:32000717" + addedTitle, //RC 32000717 : Vyřizuje v EPK
                    detailsDirection: "vertical",
                    name: "epkItemsVyriz",
                    details: this.scoreboardItem.set(vyrizuje),
                }));
            }

            if (zada != null && zada.length > 0) {
                data.push(new GObservableObject({
                    id: "ZadaEpk",
                    title: "jres:32000718" + addedTitle, //RC 32000718 : Žádá v EPK
                    detailsDirection: "vertical",
                    name: "epkItemsZada",
                    details: this.scoreboardItem.set(zada)
                }));
            }

            if (colorbarPrimary === false) {
                var kpi = this.setColorKpi(cnt, colors, titleColor);
                if(kpi != null)
                    data.push(kpi);
            }

            return data;
        } 

        private setColorKpi(cnt: GContentType<any>, colors: EpkScoreboardParams[], title: string) {
            if (colors != null && colors.length > 0) {
                return new GObservableObject({
                    id: "colorEpk",
                    title: title,
                    detailsDirection: "vertical",
                    name: "epkItemsColor",
                    details: this.scoreboardItem.set(colors)
                });
            }
            return null;
        }

        private generateKpi(cnt: GContentType<any>, modelCounts: Gordic.Wfl.Interface.GEpkSouhrnCountsDto, visible: { vraceno: boolean, vyrizeno: boolean, vlastni: boolean }, opt?: IEpkScoreboardOpt): IKpiOut {

            var vyrizuje: EpkScoreboardParams[] = [];
            var zada: EpkScoreboardParams[] = [];
            var colors: EpkScoreboardParams[] = [];

            if (cnt.globalSettings == null)
                return { vyrizuje: vyrizuje, zada: zada, colors: colors };

            const ID_KVyrizeni = "KVyrizeniZadostiEpkId";
            const ID_Vraceno = "VracenoKPrepracovaniEpkId";
            const ID_Vyrizeno = "PosouzenoSchvalenoEpkId";
            const ID_Vlastni = "VlastniZadostiEpkId";

            const DisableOverviewSettlementEpk = cnt.globalSettings.get("Global.Epk.AppSettings.DisableOverviewSettlementEpk");
            const DisableOverviewRequestEpk = cnt.globalSettings.get("Global.Epk.AppSettings.DisableOverviewRequestEpk");
            const showColor: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.ShowColor");

            if (DisableOverviewSettlementEpk !== true) {

                //#region -- VYŘIZUJE --

                var epk_prehl_org = (opt == null || opt.epk_prehl_org == null) ? 0 : opt.epk_prehl_org;

                //#region * k vyřízení *

                const ToSettlementHide = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.ToSettlementHide");
                const ToSettlementIndex = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.ToSettlementIndex");

                if (ToSettlementHide === true) {
                    console.log("jres:32000985") //RC 32000985 : Úvodní přehled karty "K vyřízení" je skrytý.
                }
                else {

                    if (modelCounts.EpkPosouzeniSchvaleniNeprecteno == null)
                        modelCounts.EpkPosouzeniSchvaleniNeprecteno = 0;
                    if (modelCounts.EpkPosouzeniSchvaleni == null)
                        modelCounts.EpkPosouzeniSchvaleni = 0;

                    var vyrizujeCaption = String.Format("{0}/{1}", modelCounts.EpkPosouzeniSchvaleniNeprecteno.toString(), modelCounts.EpkPosouzeniSchvaleni.toString());

                    if (opt != null && epk_prehl_org > 0)   // nezobrazuji část NEPŘEČTENO
                        vyrizujeCaption = modelCounts.EpkPosouzeniSchvaleni.toString();

                    var vyrizDescription = opt != null && epk_prehl_org > 0 ?
                        "jres:32000012" : //RC 32000012 : K vyřízení
                        "jres:32000012 (N/C)"; //RC 32000012 : K vyřízení

                    vyrizuje.push({
                        itemData: {
                            description: vyrizDescription,
                            meaning: "info",
                            value: vyrizujeCaption,
                            partValue: modelCounts.EpkPosouzeniSchvaleni.toString(),
                            partPrimary: "jres:32000012", //RC 32000012 : K vyřízení
                            partSecondary: String.Format("({0}: {1})", "jres:32000894", modelCounts.EpkPosouzeniSchvaleniNeprecteno.toString()) //RC 32000894 : N
                        },
                        navigateData: {
                            customClass: "test-custom",
                            epkTermin: EpkTerminEnum.CelySeznam,
                            content: cnt,
                            actionName: "actKVyrizeniEpk",
                            ID: ID_KVyrizeni + "#",
                            taskId: ID_KVyrizeni,
                            type: EpkScoreboardNavigateEnum.KVyrizeni,
                            supervisor: epk_prehl_org
                        },
                        //@ts-ignore
                        index: ToSettlementIndex
                    })
                }

                //#endregion

                //#region * Vráceno k přepracování *

                const RejectedHide = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.RejectedHide");
                const RejectedIndex = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.RejectedIndex");

                if (RejectedHide === true) {
                    console.log("jres:32000986") //RC 32000986 : Úvodní přehled karty "Vráceno k přepracování" je skrytý.
                }
                else {

                    if (modelCounts.EpkVraceno == null)
                        modelCounts.EpkVraceno = 0;
                    if (modelCounts.EpkVracenoNeprecteno == null)
                        modelCounts.EpkVracenoNeprecteno = 0;

                    var vracenoDescription = opt != null && epk_prehl_org > 0
                        ? "jres:26265052" : //RC 26265052 : Vráceno k přepracování
                        "jres:26265052 (N/C)"; //RC 26265052 : Vráceno k přepracování

                    var vracenoValue = opt != null && epk_prehl_org > 0 ? modelCounts.EpkVraceno.toString() :
                        String.Format("{0}/{1}", modelCounts.EpkVracenoNeprecteno.toString(), modelCounts.EpkVraceno.toString());

                    if (visible.vraceno === true) {
                        vyrizuje.push({
                            itemData: {
                                description: vracenoDescription,
                                meaning: "info",
                                value: vracenoValue,
                                partValue: modelCounts.EpkVraceno.toString(),
                                partPrimary: "jres:26265052", //RC 26265052 : Vráceno k přepracování
                                partSecondary: String.Format("({0}: {1})", "jres:32000894", modelCounts.EpkVracenoNeprecteno.toString()) //RC 32000894 : N
                            }, // EpkVraceno
                            navigateData: {
                                epkTermin: EpkTerminEnum.CelySeznam,
                                content: cnt,
                                actionName: "actEpkPosouzeniSchvaleni",
                                ID: ID_Vraceno + "#",
                                taskId: ID_Vraceno,
                                type: EpkScoreboardNavigateEnum.VracenoKPrepracovani,
                                supervisor: epk_prehl_org
                            },
                            //@ts-ignore
                            index: RejectedIndex
                        })
                    }
                }

                //#endregion

                //#region * Posouzeno / Schváleno *

                const SettlementHistoryHide = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.SettlementHistoryHide");
                const SettlementHistoryIndex = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.SettlementHistoryIndex");

                if (SettlementHistoryHide === true) {
                    console.log("jres:32000987") //RC 32000987 : Úvodní přehled karty "Historie vyřízení" je skrytý.
                }
                else {
                    if (visible.vyrizeno === true) {
                        vyrizuje.push({
                            itemData: {
                                description: "jres:32000988", //RC 32000988 : Historie vyřízení
                                meaning: "info",
                                value: modelCounts.EpkPosouzenoSchvaleno
                            },
                            navigateData: {
                                epkTermin: EpkTerminEnum.CelySeznam,
                                content: cnt,
                                actionName: "actEpkPosouzenoSchvaleno",
                                ID: ID_Vyrizeno + "#",
                                taskId: ID_Vyrizeno,
                                type: EpkScoreboardNavigateEnum.PosouzenoSchvaleno,
                                supervisor: epk_prehl_org
                            },
                            //@ts-ignore
                            index: SettlementHistoryIndex
                        })
                    }
                }

                //#endregion

                //#region * Nevyřízeno před termínem *

                const BeforeToSettlementHide = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.BeforeToSettlementHide");
                const BeforeToSettlementIndex = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.BeforeToSettlementIndex");

                if (BeforeToSettlementHide === true) {
                    console.log("jres:32000989"); //RC 32000989 : Úvodní přehled karty "Nevyřízeno před termínem" je skrytý.
                }
                else {
                    vyrizuje.push({
                        itemData: {
                            // Nevyřízeno před termínem
                            description: "jres:32000471", //RC 32000471 : Před termínem
                            meaning: "info",
                            value: modelCounts.EpkNevyrizenoPred
                        },
                        navigateData: {
                            epkTermin: EpkTerminEnum.Pred,
                            content: cnt,
                            actionName: "actEpkNevyrizenoPred",
                            ID: ID_KVyrizeni + "#",
                            taskId: ID_KVyrizeni,
                            type: EpkScoreboardNavigateEnum.KVyrizeni,
                            supervisor: epk_prehl_org
                        },
                        //@ts-ignore
                        index: BeforeToSettlementIndex,
                    })
                }

                //#endregion

                //#region * Nevyřízeno těsně před termínem *

                const JustBeforeToSettlementHide = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.BeforeToSettlementHide");
                const JustBeforeToSettlementIndex = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.JustBeforeToSettlementIndex");

                if (JustBeforeToSettlementHide === true) {
                    console.log("jres:32000990") //RC 32000990 : Úvodní přehled karty "Nevyřízeno těsně před termínem" je skrytý.
                }
                else {
                    vyrizuje.push({
                        itemData: {
                            // Nevyřízeno těsně před termínem
                            description: "jres:32000992", //RC 32000992 : Těsně před termínem
                            meaning: "negative",
                            value: modelCounts.EpkNevyrizenoTesnePred
                        },
                        navigateData: {
                            epkTermin: EpkTerminEnum.TesnePred,
                            content: cnt,
                            actionName: "actEpkNevyrizenoTesnePred",
                            ID: ID_KVyrizeni + "#",
                            taskId: ID_KVyrizeni,
                            type: EpkScoreboardNavigateEnum.KVyrizeni,
                            supervisor: epk_prehl_org
                        },
                        //@ts-ignore
                        index: JustBeforeToSettlementIndex,
                    })
                }

                //#endregion

                //#region * Nevyřízeno po termínu *

                const AfterToSettlementHide = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.AfterToSettlementHide");
                const AfterToSettlementIndex = cnt.globalSettings.get("Global.Epk.AppSettings.SettlementPanel.AfterToSettlementIndex");

                if (AfterToSettlementHide === true) {
                    console.log("jres:32000991") //RC 32000991 : Úvodní přehled karty "Nevyřízeno po termínu" je skrytý.
                }
                else {
                    vyrizuje.push({
                        itemData: {
                            // Nevyřízené po termínu
                            description: "jres:32000473", //RC 32000473 : Po termínu
                            meaning: "negative",
                            value: modelCounts.EpkPoTerminu
                        },
                        navigateData: {
                            epkTermin: EpkTerminEnum.Po,
                            content: cnt,
                            actionName: "actEpkPoTerminu",
                            ID: ID_KVyrizeni + "#",
                            taskId: ID_KVyrizeni,
                            type: EpkScoreboardNavigateEnum.KVyrizeni,
                            supervisor: epk_prehl_org
                        },
                        //@ts-ignore
                        index: AfterToSettlementIndex,
                    })
                }

            //#endregion

            //#endregion

                if (vyrizuje.length > 0) {
                    vyrizuje.sort(function (a, b) {
                        if (a["index"] < b["index"])
                            return -1;
                        else if (a["index"] > b["index"])
                            return 1;
                        else
                            return 0;
                    });
                }

            }

            if (DisableOverviewRequestEpk !== true) {

                //#region -- ŽÁDÁ  --

                if (visible.vlastni === true) {


                    if (modelCounts.EpkVlastniVyrizeno == null)
                        modelCounts.EpkVlastniVyrizeno = 0;
                    if (modelCounts.EpkVlastniVraceno == null)
                        modelCounts.EpkVlastniVraceno = 0;
                    if (modelCounts.EpkVlastniNevyrizeno == null)
                        modelCounts.EpkVlastniNevyrizeno = 0;

                    zada.push(this.createCardOwn({
                        name: "EpkVlastniVyrizeno",
                        cnt: cnt,
                        label: String.Format("{0} ({1})", "jres:32000714", "jres:32000894"),
                        stavZadosti: Wfl.Interface.GWflczpvEnum.Povoleno,
                        value: modelCounts.EpkVlastniVyrizeno,
                        partPrimary: "jres:32000714", //RC 32000714 : Vyřízeno
                        partSecondary: "jres:32001067" //RC 32001067 : (N)
                    }));

                    zada.push(this.createCardOwn({
                        name: "EpkVlastniVraceno",
                        cnt: cnt,
                        label: String.Format("{0} ({1})", "jres:32000715", "jres:32000894"),
                        stavZadosti: Wfl.Interface.GWflczpvEnum.VracenoKPrepracovani,
                        value: modelCounts.EpkVlastniVraceno,
                        partPrimary: "jres:32000715", //RC 32000715 : Vraceno k přepracování
                        partSecondary: "jres:32001067" //RC 32001067 : (N)
                    }));

                    zada.push(this.createCardOwn({
                        name: "EpkVlastniNevyrizeno",
                        cnt: cnt,
                        label: String.Format("{0}", "jres:32000716"),
                        stavZadosti: Wfl.Interface.GWflczpvEnum.Nevyrizeno,
                        value: modelCounts.EpkVlastniNevyrizeno,
                        partPrimary: "jres:32000716", //RC 32000716 : Nevyřízeno
                    }));


                }

            //#endregion

            }

            if (showColor === true) {

                //#region -- BARVY --

                if (modelCounts.Red == null)
                    modelCounts.Red = 0;
                if (modelCounts.Green == null)
                    modelCounts.Green = 0;
                if (modelCounts.Blue == null)
                    modelCounts.Blue = 0;
                if (modelCounts.Purple == null)
                    modelCounts.Purple = 0;
                if (modelCounts.Yellow == null)
                    modelCounts.Yellow = 0;
                if (modelCounts.White == null)
                    modelCounts.White = 0;

                var red = this.createCardColor("Red", "jres:32000852", cnt, modelCounts.Red, Wfl.Interface.GWflczpvEnum.Nevyrizeno, Gordic.Widget.GColorPicker.UzoEnum.Red, "negative"); //RC 32000852 : Červená
                if (red != null)
                    colors.push(red);

                var green = this.createCardColor("Green", "jres:32000853", cnt, modelCounts.Green, Wfl.Interface.GWflczpvEnum.Nevyrizeno, Gordic.Widget.GColorPicker.UzoEnum.Green, "positive"); //RC 32000853 : Zelená
                if (green != null)
                    colors.push(green);

                var blue = this.createCardColor("Blue", "jres:32000854", cnt, modelCounts.Blue, Wfl.Interface.GWflczpvEnum.Nevyrizeno, Gordic.Widget.GColorPicker.UzoEnum.Blue, "info"); //RC 32000854 : Modrá
                if (blue != null)
                    colors.push(blue);

                var purple = this.createCardColor("Purple", "jres:32000855", cnt, modelCounts.Purple, Wfl.Interface.GWflczpvEnum.Nevyrizeno, Gordic.Widget.GColorPicker.UzoEnum.Purple, "purple"); //RC 32000855 : Fialová
                if (purple != null)
                    colors.push(purple);

                var yellow = this.createCardColor("Yellow", "jres:32000856", cnt, modelCounts.Yellow, Wfl.Interface.GWflczpvEnum.Nevyrizeno, Gordic.Widget.GColorPicker.UzoEnum.Yellow, "yellow"); //RC 32000856 : Žlutá
                if (yellow != null)
                    colors.push(yellow);

                var white = this.createCardColor("White", "jres:32000857", cnt, modelCounts.White, Wfl.Interface.GWflczpvEnum.Nevyrizeno, Gordic.Widget.GColorPicker.UzoEnum.White, "black"); //RC 32000857 : Bílá
                if (white != null)
                    colors.push(white);

                //#endregion

            }

            if (colors.length > 0) {
                colors.sort(function (a, b) {
                    if (a["index"] < b["index"])
                        return -1;
                    else if (a["index"] > b["index"])
                        return 1;
                    else
                        return 0;
                });
            }

            return { vyrizuje: vyrizuje, zada: zada, colors: colors };

        }

        private createCardColor(name: string, label: string, cnt: GContentType<any>, value: number, stavZadosti: Wfl.Interface.GWflczpvEnum, uzo: string, meaning?: "info" | "negative" | "positive" | "purple" | "yellow" | "black") {

            var Id = "KVyrizeniZadostiEpkId#";
            var TaskId = "actKVyrizeniEpk";

            if (meaning == null)
                meaning = "info";

            var indexColor: string = "0";

            if (cnt.globalSettings != null) {

                // zobrazit pouze vyplněné barvy
                var showOnlyFillColor: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.ShowOnlyFillColor");
                if (showOnlyFillColor === true && (value == null || value === 0))
                    return null; 

                // zobrazit pouze uživatelské barvy
                var showOnlyUserLabelColor: boolean = cnt.globalSettings.get("Global.Epk.AppSettings.ShowOnlyUserLabelColor");
                var userLabel: string = cnt.globalSettings.get("Global.Epk.AppSettings.OthersSettings.GColorPicker." + name);
                indexColor = cnt.globalSettings.get("Global.Epk.AppSettings.OthersSettings.GColorPicker." + name + "Index");

                if (showOnlyUserLabelColor === true && (userLabel == null || userLabel.trim() === "")) {
                    return null;
                }
                if (userLabel != null && userLabel.trim() !== "")
                    label = userLabel;
            }

            var result = this.createCard({
                description: label,
                value: value,
                meaning: meaning,
            }, {
                content: cnt,
                actionName: "EpkColor" + name,
                type: EpkScoreboardNavigateEnum.KVyrizeni,
                ID: Id,
                taskId: TaskId,
                stavZadosti: stavZadosti,
                uzo: uzo
            });

            result["index"] = indexColor;
            return result;
        }

        private createCardOwn(opt: { name: string, label: string, cnt: GContentType<any>, value: number, stavZadosti: Wfl.Interface.GWflczpvEnum, partPrimary?: string, partSecondary?: string }) {

            var IDVlastni = "VlastniZadostiEpkId#";
            var TaskIDVlastni = "actVlastniZadostiEpk";

            return this.createCard(
            {
                    description: opt.label,
                    value: opt.value,
                    meaning: "info",
                    partPrimary: opt.partPrimary,
                    partSecondary: opt.partSecondary
                }, {
                    content: opt.cnt,
                    actionName: opt.name,
                    type: EpkScoreboardNavigateEnum.VlastniZadosti,
                    ID: IDVlastni,
                    taskId: TaskIDVlastni,
                    stavZadosti: opt.stavZadosti,
            })
        }

        private createCard(itemData: ScoreboardItemData, navigateData: IScoreboardNavigateParam) {

            if (itemData.meaning == null)
                itemData.meaning = "info";
            if (navigateData.epkTermin == null)
                navigateData.epkTermin = EpkTerminEnum.CelySeznam;

            var param: EpkScoreboardParams = {
                itemData: {
                    description: itemData.description,
                    meaning: itemData.meaning,
                    value: itemData.value,
                    partPrimary: itemData.partPrimary,
                    partSecondary: itemData.partSecondary
                },
                navigateData: {
                    epkTermin: EpkTerminEnum.CelySeznam,
                    content: navigateData.content,
                    actionName: "act" + navigateData.actionName,
                    ID: navigateData.ID,
                    taskId: navigateData.taskId,
                    type: navigateData.type,
                    stavZadosti: navigateData.stavZadosti,
                    uzo: navigateData.uzo
                }
            };
            return param;
        }

    }

    /** část nástěnky pro navigaci na konkrétní seznam */
    export class ScoreboardNavigate implements IScoreboardNavigate {
        navigate(param: IScoreboardNavigateParam) {
            var obj: any = { ID: param.ID, taskId: param.taskId, TypSeznamu: param.type, EpkTermin: param.epkTermin };
            if (param.stavZadosti != null) 
                obj["stavZadosti"] = param.stavZadosti;
            if (param.supervisor != null)
                obj["supervisor"] = param.supervisor;
            if (param.uzo != null)
                obj["uzo"] = param.uzo;
            if (param.cardView != null)
                obj["cardView"] = param.cardView;
            // @ts-ignore
            Epk.Dialogs.SeznamyEpkDlg(param.content, obj, Gin.Globals.Enums.ModOtevreni.navigate);
        }
    }

    /** jeden item nástěnky */
    export class ScoreboardItem implements IScoreboardType{

        set(params: EpkScoreboardParams[]) {
            var detailsOfItems: IScoreboardItem[] = [];
            for (var index = 0; index < params.length; index++) {
                const item = params[index];
                const detail = this.create(item.itemData, item.navigateData);
                detailsOfItems.push(detail);
            }
            return detailsOfItems;
        }

        create(itemData: ScoreboardItemData, navigateData: IScoreboardNavigateParam) {

            var item = {
                value: itemData.value,
                description: itemData.description,
                meaning: itemData.meaning,
                action: new GAction({
                    name: navigateData.actionName,
                    run: () => {
                        var ScoreboardNavigate = new Gordic.Epk.WebControls.ScoreboardNavigate();
                        ScoreboardNavigate.navigate(navigateData);
                    }
                })
            };
            return item;
        }

    }


}

